import React, { useCallback, useState } from "react";

import useAxios from "../../hooks/useAxiosChat";

import CustomButton from "../button/CustomButton";
import { CustomInput } from "../Inputs/Inputs";
import { mobileChecker } from "../../utilities/regexCheckers";

interface EnterPhoneNumberChatProps {
  mobile: string;
  setMobile: (state: string) => void;
  setStep: (state: number) => void;
  setHashCode: (state: string) => void;
}

const EnterPhoneNumberChat: React.FC<EnterPhoneNumberChatProps> = ({
  mobile,
  setMobile,
  setStep,
  setHashCode,
}) => {
  const { execute, loading } = useAxios("api/getlogincode");

  const [errorMessage, setErrorMessage] = useState("");

  const mobileInputChangeHandler = useCallback<
    React.ChangeEventHandler<HTMLInputElement>
  >(
    (event) => {
      setMobile(event.target.value);
    },
    [setMobile]
  );

  const submit = useCallback<React.MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.preventDefault();
      if (loading) return;
      if (!mobileChecker(mobile)) {
        setErrorMessage("لطفا شماره تماس را به درستی وارد نمایید.");
        return;
      } else if (errorMessage !== "") {
        setErrorMessage("");
      }
      execute({
        mobile,
      }).then((res) => {
        if (+res.status === 1) {
          setHashCode(res.data.hashcode);
          setStep(2);
        }
      });
    },
    [mobile, execute, loading, setHashCode, setStep]
  );

  return (
    <form>
      <CustomInput
        type="text"
        label="برای وارد شدن به سایت، لطفا شماره تلفن همراه خود را وارد نمایید."
        labelClassName="login-input-label mb-3"
        inputContainer="mb-4 mx-2"
        inputValue={mobile}
        placeholder="09XXXXXXXXX"
        // @ts-ignore
        onChangeFunc={mobileInputChangeHandler}
        textErr={errorMessage}
      />
      <div className="login-button-box">
        <CustomButton
          color="primary"
          className="btn btn-primary px-3 py-2 w-25 justify-content-center"
          btnType="submit"
          onClick={submit}
        >
          بعدی
        </CustomButton>
      </div>
    </form>
  );
};

export default EnterPhoneNumberChat;
